import React, { useState, useEffect } from 'react';
import { map, without, get, size } from 'lodash';
import { object } from 'prop-types';
import { withApollo } from 'react-apollo';
import { FlexContainer, Main, Row, Checkbox, Column, Button, Pagination, Loading } from '../../common';
import Filters from './Filters';
import Card from './Card';
import { useReset } from '../../../utils/misc';
import { Query } from '../../graphql';
import { GET_BLACKLIST, DELETE_BLACKLIST_ITEM } from '../../../queries';

const Blacklist = ({ client }) => {
    const [allSelected, setAllSelected] = useState(false);
    const [reloadingCards, setReloadingCards] = useState(false);
    const [selectedCards, setSelectedCards] = useState([]);
    const [items, setItems] = useState([]);

    useEffect(() => useReset(setReloadingCards), [allSelected]);

    const onCheck = (ean, value) => {
        if (value) return setSelectedCards([...selectedCards, ean]);
        return setSelectedCards(without(selectedCards, ean));
    };

    const onCheckAll = (value) => {
        setAllSelected(value);
        if (value) return setSelectedCards(map(items, 'ean'));
        return setSelectedCards([]);
    };

    const deleteItem = async () => {
        await client.mutate({
            mutation: DELETE_BLACKLIST_ITEM,
            variables: {
                ean: selectedCards[0]
            }
        });
    };

    return (<Main background='f4f4f4' withFooter>
        <Filters />
        <FlexContainer marginHorizontal={26} wrap direction='column'>
            <Row padding={7}>
                <Column>
                    <Pagination total={100} />
                </Column>
            </Row>
            <Row padding={7}>
                <Column>
                    <Checkbox label='Seleccionar todo' onChange={onCheckAll} />
                </Column>
                <Column align='end'>
                    <Button
                        icon='trash'
                        text='Eliminar seleccionado(s)'
                        textTransform='none'
                        fitContent
                        disabled={!(size(selectedCards) > 0)}
                        onClick={deleteItem}
                    />
                </Column>
            </Row>
            <Row>
                <Query query={GET_BLACKLIST} variables={{}}>
                    {({ data, loading }) => {
                        !loading && setItems(get(data, 'getAllItems.payload'));

                        return <Loading loading={loading}>
                            {!reloadingCards && map(items, (item) =>
                                <Card
                                    {...item}
                                    onCheck={value => onCheck(get(item, 'ean'), value)}
                                    allSelected={allSelected}
                                />
                            )}
                        </Loading>;
                    }}
                </Query>
            </Row>
        </FlexContainer>
    </Main>);
};

Blacklist.propTypes = {
    client: object
};

export default withApollo(Blacklist);
